import { CustomCollapseCard, Text } from '@src/components';
import { Radio } from 'antd';
import '@src/styles/cardOrder/payment-type.scss';
import { useMediaQuery } from '@src/hooks/useMediaQuery';
import { useDispatch, useSelector } from 'react-redux';
import { setPaymentType } from '@src/store/slice/mobilExpressSlice';
import { useEffect } from 'react';
import { getCustomerVouList } from '@src/store/slice/customerSlice';
import { cardOrdersUpdate } from '@src/store/slice/cardOrderSlice';

const PaymentType = () => {
  const isMobil = useMediaQuery({ query: '(max-width: 991.98px)' });
  const { paymentType } = useSelector((state) => state?.mobilExpress);
  const { customerVou } = useSelector((state) => state?.customer);
  const { currentCardOrder } = useSelector((state) => state?.cardOrder);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getCustomerVouList({
        customerId: currentCardOrder?.customerId,
        vouId: currentCardOrder.vouId,
      }),
    );
  }, [currentCardOrder?.customerId, currentCardOrder.vouId, dispatch]);

  useEffect(() => {
    if (!customerVou?.customerId) return;
    (async () => {
      if (customerVou?.pamId === 4 && customerVou?.patId === 2) {
        dispatch(setPaymentType(1));
        dispatch(cardOrdersUpdate({ ...currentCardOrder, paymentType: 4 }));
      } else {
        dispatch(setPaymentType(2));
        dispatch(cardOrdersUpdate({ ...currentCardOrder, paymentType: 5 }));
      }
      if (
        (customerVou?.pamId === 2 && customerVou?.patId === 2) ||
        (customerVou?.pamId === 5 && customerVou?.patId === 1)
      ) {
        await paymentLater();
        return;
      }
      if (
        (customerVou?.pamId === 1 && customerVou?.patId === 1) ||
        (customerVou?.pamId === 4 && customerVou?.patId === 1)
      ) {
        await paymentLater();
      }
    })();
  }, [customerVou, dispatch]);
  useEffect(() => {
    setPaymentType(null);
  }, []);
  useEffect(() => {
    if (customerVou?.pamId === 4) {
      dispatch(setPaymentType(1));
    }
  }, [customerVou]);
  return (
    <CustomCollapseCard
      bodyCenter={!isMobil}
      cardTitle={<Text t="paymentTypeTitle" />}
      cardTitleAlign="center"
    >
      <Radio.Group
        id="ticketRestaurant-cardOrders-payment-paymentTypee-custom-radioGroup-input-content"
        onChange={async (e) => {
          await dispatch(
            cardOrdersUpdate({ ...currentCardOrder, paymentType: e.target.value === 1 ? 4 : 5 }),
          );
          await dispatch(setPaymentType(e.target.value));
        }}
        value={paymentType}
        className="custom-radio-input-content"
      >
        {customerVou?.pamId === 4 && (
          <Radio id="ticketRestaurant-cardOrders-payment-paymentTypee-custom-radio-input-content1" value={1} className={paymentType === 2 ? 'ant-radio-wrapper-unchecked' : null}>
            <div className="credit-card-title">
              <Text t="creditcard" />
            </div>
          </Radio>
        )}

        <Radio id="ticketRestaurant-cardOrders-payment-paymentTypee-custom-radio-input-content2" value={2} className={paymentType === 1 ? 'ant-radio-wrapper-unchecked' : null}>
          <div className="eftTransfer-card-title">
            <Text t="eftTransfer" />
          </div>
        </Radio>
      </Radio.Group>
    </CustomCollapseCard>
  );
};

export default PaymentType;
